module.exports = __webpack_public_path__ + "img/application.5728c250.png";